var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('bootstrap-five/js/dist/carousel');
require('bootstrap-five/js/dist/collapse');
require('bootstrap-five/js/dist/dropdown');
require('bootstrap-five/js/dist/modal');
require('bootstrap-five/js/dist/tab');

require('bootstrap-select');
require('pc-bootstrap4-datetimepicker');

// require('feather-icons');
const feather = require('feather-icons')

// require('jquery-sticky');
require('@fortawesome/fontawesome-free');

require('mmenu-js');
require('@iconify/iconify');

$(function() {

    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    // initAjaxJS();

    //feather icons
    feather.replace()

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }
});


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
// function initAjaxJS() {


// }

document.addEventListener(
    "DOMContentLoaded", () => {
        const menu = new Mmenu( "#mmenu", {
            "content": [
                "prev", 
                "title"
            ],
            extensions: ["position-bottom"],
        });

        const api = menu.API;
        var currentScrollPos = 0;

        document.querySelector('.btn-menu')
        .addEventListener(
            "click", ( evnt ) => {       
                currentScrollPos = document.documentElement.scrollTop;
                document.querySelector('html').classList.remove('scroll-smooth');
                evnt.preventDefault();
                api.open();
            }
        );
        document.querySelector('.mm-wrapper__blocker')
        .addEventListener(
            "click", ( evnt ) => {
                window.scrollTo(0, currentScrollPos);
                document.querySelector('html').classList.add('scroll-smooth');
            }
        );
         
    }
);

// define PX here in which to change
const scrollchange = 80;
const scrollpos = window.scrollY;
const header = document.getElementById('navbar');

window.addEventListener('scroll', function(){ 
    let scrollpos = window.scrollY;
    if (scrollpos > scrollchange){
        header.classList.add('scrolling');
    }
    else {
        header.classList.remove('scrolling');
    }
});

let scrollToTopBtn = document.querySelector("#scrollToTop");
scrollToTopBtn.addEventListener("click", scrollToTop);

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}

let customFiles = document.querySelectorAll('.custom-file-input,.custom-file-button-input')
customFiles.forEach(item => {
    item.addEventListener('click', event => {
        if (typeof(item) != 'undefined' && item != null) {
            item.addEventListener('change',function(e){
                
                let failedValidation = false;

                // allowed files
                let allowedFiletypes = item.dataset.allowedFiletypes.split(',');
                let allowedFilesize = item.dataset.allowedSize;
                let allowedFileCount = item.dataset.maxUploads;

                // error field
                const errorField = e.target.closest('.custom-file-button,.custom-file').querySelector('.custom-file-errors');

                // reset data
                item.classList.remove('is-invalid');
                //e.target.nextElementSibling.innerText = 'Choose a file to upload...';
                errorField.innerHTML = '';

                if (!customfileCheckExtension(item, allowedFiletypes)) {
                    item.classList.add('is-invalid');
                    errorField.innerHTML = errorField.innerHTML + 'Invalid file extension(s).<br>';
                    failedValidation = true;
                } 

                if (!customfileCheckSize(item, allowedFilesize)) {
                    item.classList.add('is-invalid');
                    errorField.innerHTML = errorField.innerHTML + 'File(s) uploaded is too large.<br>';
                    failedValidation = true;
                } 

                if (!customfileCheckMax(item, allowedFileCount)) {
                    item.classList.add('is-invalid');
                    errorField.innerHTML = errorField.innerHTML + 'You may only choose up to ' + allowedFileCount + ' file(s).<br>';
                    failedValidation = true;
                } 

                if (failedValidation) {
                    return false;
                } else {
                    if (item.getAttribute('multiple') == 'multiple' && item.files.length > 1) {
                        let files = item.files;
                        let nextSibling = e.target.nextElementSibling
                        nextSibling.innerText = item.files.length + ' files selected.';
                    } else {
                        let fileName = item.files[0].name;
                        let nextSibling = e.target.nextElementSibling
                        nextSibling.innerText = fileName
                    }
                }
            });
        }
    })
  })

  function customfileCheckExtension(item, allowedFiletypes) {
    for (var i = 0; i < item.files.length; i++) {
        let ext = '.' + item.files[i].name.split('.').pop();

        if (!allowedFiletypes.includes(ext)) {  
            return false;
        }      
    }
    return true;
  }

  function customfileCheckSize(item, allowedFilesize) {
    for (var i = 0; i < item.files.length; i++) {
        if ((item.files[i].size/1024/1024) > allowedFilesize) {  
            return false;
        }
    }
    return true;
  }

  function customfileCheckMax(item, allowedFileCount) {
    if (item.files.length > allowedFileCount) {
        return false;
    }
    return true;
  }